import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiCall, apiCallAdmin } from "./services/api-service";
import { Container, Row, Col, Toast, } from "react-bootstrap";
import signage_logo from "./assets/svg/signage_logo.svg";
function PreLanding() {
   const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
   const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiCallAdmin("GET", "get_role_permission/30");
        if (response.status === 200) {
          navigate('/dashboard/default');
        }
      } catch (error) {
        console.error(error);
        if (error.response?.status === 401) {
          document.cookie = 'redirectPath=' + window.location.href + '; path=/; domain=.mawalog.com';
          document.cookie = 'mawalog=; path=/; domain=.mawalog.com';
          window.location.href = accountsUrl;
        }
      }
    };

    fetchData();
  }, [navigate]);

  return <Container fluid style={{ width: '100vw',height: '100vh', display: 'flex',alignItems:'center',justifyContent:'center', background:'#ffffff', paddingLeft: '0px', paddingRight: '0px' }}>
   <img src={signage_logo} alt="Signage Icon"  width={'500px'}/>
  
   </Container>;
}

export default PreLanding;
